<section class="mt-section" v-if="ready.state === 'set'">
  <div v-if="foundries.length === 1" class="mt-serif mt-serif--bold" :class="$style.label">Foundry</div>
  <foundry-dropdown
    v-if="submissionPermissionFoundries.length > 1"
    :errorCSS="$style.errorField"
    :foundryDD="$style.foundryDD"
    :inputWidth="$style.inputWidth"
    :getSelectedFoundry="getFoundry"
    name="foundry upload"
    label="foundry"
    :id="$vId(this)"
    from="submissions"
  ></foundry-dropdown>
  <div v-if="submissionPermissionFoundries.length === 1" :class="$style.foundryName">{{ submissionPermissionFoundries[0].name }}</div>
  <div v-if="submissionFoundry.credibility === 'Acceptable'" :class="$style.autoApprovedBanner" class="mt-group">
    {{ $t('pages.submissions.components.confirmation.credibility.auto_approved') }}
  </div>
</section>